<template>
  <div id="app">
    <router-view />
    
    <div v-show="is_show_footer" id="footer" class="footer">
      <!-- 1. 首页 (默认选中为红色纸飞机) -->
      <router-link to="/" class="footer_item" :class="show_icon_type === 'index' ? 'footer_item_active' : ''">
        <span class="footer_icon">
          <svg v-if="show_icon_type === 'index'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#e50914" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"></path><path d="M22 2l-7 20-4-9-9-4 20-7z"></path></svg>
          <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"></path><path d="M22 2l-7 20-4-9-9-4 20-7z"></path></svg>
        </span>
        <p class="footer_info">{{ $t('home.index') }}</p>
      </router-link>
      
      <!-- 2. 投资 (天平图标) -->
      <router-link to="/invest" class="footer_item" :class="show_icon_type === 'invest' ? 'footer_item_active' : ''">
        <span class="footer_icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f5b041" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20"></path><path d="M6 6h12l-6 10L6 6z"></path><path d="M10 16H14"></path><rect x="5" y="18" width="14" height="2" rx="1"></rect></svg>
        </span>
        <p class="footer_info">{{ $t('home.invest') }}</p>
      </router-link>
      
      <!-- 3. 我的团队 (团队头像图标 - 移除重复路由) -->
      <router-link to="/team" class="footer_item" :class="show_icon_type === 'team' ? 'footer_item_active' : ''">
        <span class="footer_icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#e67e22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="7" r="4"></circle><path d="M3 21v-2a6 6 0 0 1 12 0v2"></path><circle cx="15" cy="7" r="4" stroke="#2980b9"></circle><path d="M21 21v-2a6 6 0 0 0-4-5.7" stroke="#2980b9"></path></svg>
        </span>
        <p class="footer_info">{{ $t('home.team') }}</p>
      </router-link>
      
      <!-- 4. 论坛 (选中状态为蓝色文字) -->
      <router-link to="/lun" class="footer_item" :class="show_icon_type === 'lun' ? 'footer_item_active' : ''">
        <span class="footer_icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" :stroke="show_icon_type === 'lun' ? '#1d4ed8' : '#e74c3c'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path><path d="M8 10h.01"></path><path d="M12 10h.01"></path><path d="M16 10h.01"></path></svg>
        </span>
        <p class="footer_info" >{{ $t('utils.luntan') }}</p>
      </router-link>
      
      <!-- 5. 个人中心 (绿色人物 + 金币) -->
      <router-link to="/user" class="footer_item" :class="show_icon_type === 'user' ? 'footer_item_active' : ''">
        <span class="footer_icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1abc9c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle><circle cx="18" cy="17" r="4" fill="#f1c40f" stroke="#f1c40f"></circle><path d="M20.5 16.5L16.5 20.5" stroke="#fff"></path></svg>
        </span>
        <p class="footer_info">{{ $t('home.my') }}</p>
      </router-link>
    </div>

    <!-- 全局 Loading -->
    <div v-if="show_loading_wrap" class="loading_wrap">
      <img :src="require('./views/img/index/loading.gif'+'')" alt="">
    </div>
  </div>
</template>

<script>
import Fetch from "./utils/fetch";

export default {
  name: 'App',
  data() {
    return {
      show_icon_type: 'index',
      is_show_footer: true,
      show_loading_wrap: true,
      lang: 'id_id'
    }
  },
  updated() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  mounted() {
    const token = localStorage.getItem('token');
    if (token) {
      this.$store.commit('setLogin', { token: token });
    }
    this.start();
  },
  methods: {
    onSwipeLeft(even, start, end) {
      if (end['X'] - start['X'] > 60) {
        this.$router.go(-1);
      }
    },
    footer: function(type = 'index', show_footer = true) {
      this.show_icon_type = type;
      this.is_show_footer = show_footer;
    },
    start() {
      var reload = false;
      if (localStorage.getItem("reload")) {
        reload = true;
      }
      Fetch("/index/webconfig", {
        reload: reload
      }, "", false).then((r) => {
        this.setLang(r.data.language);
        window.document.title = r.data.webname;
        localStorage.setItem("logo", r.data.logo);
        localStorage.setItem("logo2", r.data.logo2);
        localStorage.setItem('currency', "");
        localStorage.setItem('precision', r.data.precision);
        localStorage.setItem('currency_symbol_basic', 'EUR');
        localStorage.setItem('precision_basic', 0);
        localStorage.setItem("language_logo", r.data.language_logo);
      });
    },
    setLang(lang) {
      if (!localStorage.getItem("lang")) {
        localStorage.setItem("lang", lang);
        this.$i18n.locale = lang;
        localStorage.setItem("reload", true);
        location.reload();
      } else {
        this.show_loading_wrap = false;
      }
    }
  }
}
</script>

<style lang="less">
/* =============== 全局重置 & 字体 =============== */
html, body {
  width: 100%;
  height: 100%;
}
html::-webkit-scrollbar, body::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

:root {
  /* 为了匹配截图，这里重新定义明亮模式变量，请注意与您的业务逻辑兼容 */
  --bg-primary: #f4f7fc; 
  --bg-secondary: #ffffff;
  --bg-card: #ffffff;
  --text-primary: #111111;
  --text-secondary: #555555;
  --text-muted: #888888;
  --border: #e5e7eb;
  --safe-bottom: env(safe-area-inset-bottom, 16px);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

body {
  font-family: 'Inter', 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background-color: var(--bg-primary);
  display: flex;
  justify-content: center;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
}

#app {
  width: 100%;
  max-width: 430px;
  min-height: 100vh;
  background-color: var(--bg-primary);
  position: relative;
  overflow-x: hidden;
}

/* =============== 底部导航栏 (FOOTER) 样式重写 =============== */
#app .footer {
  position: fixed;
  margin: 0 auto;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 430px;
  height: 60px;
  z-index: 4;
  display: flex;
  justify-content: space-around;
  align-items: center;
  
  /* 截图中的纯白底色 + 顶部阴影 */
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.04);
  padding-bottom: var(--safe-bottom);
}

#app .footer .footer_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  width: 20%;
  color: #333333; /* 默认黑色文字 */
}

/* 图标容器 */
#app .footer .footer_item .footer_icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  margin-bottom: 4px;
}

#app .footer .footer_item .footer_icon svg {
  display: block;
  width: 100%;
  height: 100%;
}

/* 下方文字 */
#app .footer .footer_item .footer_info {
  font-size: 11px;
  font-weight: 600;
}

/* 选中状态 */
#app .footer .footer_item.footer_item_active {
  color: #e50914; /* 选中后默认红色 */
}
#app .footer .footer_item.footer_item_active .footer_info {
  font-weight: 700;
}

/* =============== 图片Loading =============== */
.loading_wrap {
  width: 100%;
  height: 100vh;
  position: absolute;
  background: #FFFFFF;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading_wrap img {
  width: 150px;
  height: 150px;
}

/* =============== 其他全局工具类 =============== */
.flex_center { display: flex; justify-content: space-between; align-items: center; }
.color_red { color: #FF0000; }
.color_green { color: #3CB371; }
.color_blue { color: #3775f4; }
</style>